import { Duration } from 'luxon'

import { FieldValue } from './field.class'

export class DurationValue extends FieldValue<Duration> {
  constructor(value?: string | Duration | { hours: number; minutes: number; seconds: number }) {
    super()
    this.parseValue(value)
  }

  public mapField(field: any): void {
    this.parseValue(field.value)
  }

  public toStringForView(): string {
    return this.value ? this.value.toFormat('hh:mm:ss') : ''
  }

  /**
   * Custom serialization to serialize the value in the accepted .NET format
   * that expects the hours to have two decimal places (example accepted duration: 12.00:21:06).
   */
  public toJSON() {
    const value = this.value ? `${this.value.hours}.00:${this.value.minutes}:${this.value.seconds}` : null
    return { ...this, value }
  }

  /**
   * Parse the value from the possible accepted formats. When the value is coming from the API,
   * it will be a string. If it's coming from user input, it will be a duration object.
   * If it is coming from custom logic, it will also accept an existing duration.
   */
  private parseValue(value?: string | Duration | { hours: number; minutes: number; seconds: number }) {
    if (value instanceof Duration) {
      this.value = value
    } else if (typeof value === 'object') {
      this.value = Duration.fromObject(value!)
    } else if (typeof value === 'string') {
      const parts = (value as string).split(':')
      const [hh, mm, ss] = parts
      const numHH = parseInt(hh)
      const numMM = parseInt(mm)
      const numSS = parseInt(ss)
      this.value = Duration.fromObject({ hours: numHH, minutes: numMM, seconds: numSS })
    } else {
      this.value = value
    }
  }
}
